module.exports = __webpack_public_path__ + "img/syukyaku-tei-001.a10d1d1f.jpg";